
import axiosInstance from '../services/AxiosInstance';

export function getSubscriptions(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`subscription?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function deleteSubscription(id) {
    return axiosInstance.delete(`subscription/${id}`);
}

export function createSubscription(data) {
    return axiosInstance.post(`subscription`,data);
}

export function updateSubscription(id, data) {
    return axiosInstance.put(`subscription/${id}`,data);
}

export const getSubscriptionMonthlyAmount = async () => {
    const response = await axiosInstance.get('/graph/subscription-monthly-amount');
    return response.data;
};